<template>
    <div class="page container" data-page="news">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/news">News</router-link>
        </div>
        
        <h1 class="title">News</h1>

        <nav class="nav">
            <a
                href="#0"
                :class="{ active: filters.tags.length === 0 }"
                @click.prevent="selectFilter('all')"
            >All</a>
            <a
                v-for="tag in allTags"
                :key="tag"
                href="#0"
                @click.prevent="selectFilter(tag.toLowerCase())"
                :class="{
                    active: filters.tags.indexOf(tag.toLowerCase()) > -1
                }"
            >
                {{ tag }}
            </a>
        </nav>

        <div v-if="newsData !== null && !loading" class="newsFeedArea">

            <template v-if="newsData.results.length > 0">
                <div v-for="news in newsData.results" :key="news.uid" class="newsFeed pure-g">
                    <div class="pure-u-1 pure-u-md-1-2 pure-u-lg-1-2">
                        <div class="newsImage image" :style="{backgroundImage: 'url('+ news.data.image.url +')'}"></div>
                    </div>
                    <div class="pure-u-1 pure-u-md-1-2 pure-u-lg-1-2">
                        <div class="newsContent">
                            <div class="wrapper">
                                <p class="tags">
                                    <span v-for="tag in news.tags" :key="tag" class="badge grey">{{ tag }}</span>
                                    <span class="date">{{ news.first_publication_date | newsDate }}</span>
                                </p>
                                <h2>{{ news.data.title }}</h2>
                                <p>{{ news.data.description[0].text | trimText }}</p>
                            <router-link :to="'/news/'+ news.uid" class="btn green icon-right">View <ion-icon name="arrow-forward"></ion-icon></router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="empty"><p>No news found.</p></div>
            </template>

        </div>

        <div v-else-if="loading" class="newsFeedArea">
            <div class="loading"></div>
        </div>

    </div>
</template>

<script>
import moment from 'moment'

export default {
    data(){
        return{
            newsData: null,
            loading: false,
            filters: {
                tags: []
            },
            allTags: [
                'News',
                'Greetings',
                'Guides',
                'Immigration'
            ]
        }
    },
    mounted(){
        this.getNewsItems()
    },
    methods: {
        getNewsItems(){

            this.loading = true

            this.$prismic.client.query([
                this.$prismic.Predicates.at('document.type', 'news'),
                this.$prismic.Predicates.at('document.tags', this.filters.tags)
            ],
            {
                pageSize : 100
            }).then((document) => {

                console.log('News: ', document)
        
                if(this.filters.tags.length === 0){
                    let tempNewsData = {}
                    tempNewsData = document
                    tempNewsData.results = document.results.reverse()
                    this.newsData = tempNewsData
                }else{
                    this.newsData = document
                }

                this.loading = false
            })
        },
        selectFilter(item){
            
            let newTags = []

            if(item !== 'all'){
                // if(this.filters.tags.indexOf(item) > -1){
                //     newTags = this.filters.tags.filter(e => e !== item)
                // }else{
                //     newTags = this.filters.tags
                //     newTags.push(item)
                // }

                newTags.push(item)
            }

            this.filters.tags = newTags

            this.getNewsItems()
        }
    },
    filters: {
        trimText(value){
            let trimmedText = ''

            if(value.length > 150){
                trimmedText = value.substring(0, 150) + '...'
            }

            return trimmedText
        },
        newsDate(value){
            return moment(value).local().format('MMM DD, YYYY')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/News.vue